import classNames from 'classnames/bind';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './papper.module.scss';

const classesContext = classNames.bind(styles);

export default function Paper({
  children,
  className,
  ...restProps
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  return (
    <div
      className={classesContext(['paper', className])}
      {...restProps}>
      {children}
    </div>
  );
}
